<!--
  ~ Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
  ~ Venelin Iliev <http://veneliniliev.com>
  -->

<div [formGroup]="form">
  <!--  bindLabel="formattedName"-->
  <ng-select
    [multiple]="true"
    [items]="data"
    bindLabel="name"
    bindValue="id"
    [loading]="loader"
    [formControlName]="'locales_fake'"
    (add)="add($event.id)"
    (remove)="remove($event.value.id)"
    (clear)="clear()"
  >
    <ng-template ng-typetosearch-tmp>
      <div class="ng-option disabled">
        {{ 'START_TYPING' | translate }}
      </div>
    </ng-template>

    <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
      <div class="locale-select-option-wrapper">
        <div class="locale-name">{{ item.name }}</div>
      </div>
    </ng-template>

    <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
      <div class="ng-option disabled">
        <div>{{ 'NO_DATA_FOUND' | translate }} "{{ searchTerm }}"</div>
        <button type="button" class="btn btn-primary btn-xs w-100" (click)="addNew(searchTerm)">
          <i class="fal fa-plus"></i> {{ 'LOCALES_SELECT.ADD_NEW' | translate }}
        </button>
      </div>
    </ng-template>
  </ng-select>
</div>
